import { TemplateUtenteProfilo } from '../profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../profili-utente/utente-profilo';
import { UtenteProfiloFull } from '../profili-utente/utente-profilo-full';

export class UtenteProfiloRequest {
  utente: UtenteProfiloFull;

  constructor(utente: UtenteProfilo, templateUtenteProfilo: TemplateUtenteProfilo) {
    this.utente = new UtenteProfiloFull(utente, templateUtenteProfilo);
  };
}

